import React from 'react';

interface OrderTabProps {
  activeTab: number;
  handleTabClick: (tabIndex: number) => void;
}

const OrderTab: React.FC<OrderTabProps> = ({ activeTab, handleTabClick }) => {
  return (
    <div className="flex space-x-4 border-b border-gray-200 mb-4 bg-white rounded-lg overflow-hidden shadow-sm">
      {['Order', 'Status', 'Order History'].map((label, index) => {
        const tabIndex = index + 1;
        const isActive = activeTab === tabIndex;

        return (
          <button
            key={label}
            className={`px-5 py-2 font-semibold text-lg transition-all duration-300 
              ${isActive 
                ? 'text-white bg-[#75A7AD] shadow-md' 
                : 'text-gray-600 bg-gray-100 hover:bg-[#75A7AD] hover:text-white'}
              rounded-t-lg focus:outline-none
            `}
            onClick={() => handleTabClick(tabIndex)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default OrderTab;